import Vue from 'vue/dist/vue.esm.js'

Vue.component('correction-request-modal',
  template: JST['report_documents/correction_request_modal']()
  props: ['document_id', 'submit_url']
  data: ->
    problem: ''
    hasErrors: false
    errors:
      problem: ''
    authenticity_token: $('meta[name="csrf-token"]').attr('content')
  methods:
    submitForm: (e) ->
      e.preventDefault()
      $.ajax
        url: @submit_url
        method: 'POST'
        data:
          correction_request_row:
            report_document_id: @document_id
            problem: @problem
          authenticity_token: @authenticity_token
        success: =>
          @closeModal()
          @$emit('state-locked')
        error: (response) =>
          error = response.responseJSON[0]
          @errors.problem = error
          @hasErrors = true

    closeModal: ->
      @$emit('close-modal')
)
